import { useContext } from 'react';
import { Row } from 'react-bootstrap';
import { PermintaanProduksiContext } from '../../Context';
import { TableLCF } from './TableLCF';

export const ContainerLCF = ({ showHistory }) => {
  const { dataLCF } = useContext(PermintaanProduksiContext);

  return (
    <Row>
      <TableLCF
        jobOrder
        showTotalPrice
        title="List Labour Cost Finishing Dari Job Order"
        data={dataLCF.jobOrder}
      />
      <TableLCF
        showInputRow
        showTotalPrice
        title="List Labour Cost Finishing"
        data={dataLCF.permintaan}
      />
      {showHistory && (
        <TableLCF
          readOnly
          title="History Permintaan Labour Cost Finishing"
          data={dataLCF.history}
        />
      )}
    </Row>
  );
};
